import api from "./common";
import cogoToast from "cogo-toast";
import { constants } from "../components/Dashboard/const";

export const postReading = async (storyID, token, setLoading) => {
  console.log(setLoading);
  const response = await api.get(
    `/stories/reading/${storyID}`,
    token,
    {},
    setLoading
  );

  if (!(response.status || response.success)) {
    console.log(response);
    return;
  }
};

export const getStory = async (dispatch, storyID, token, args, setLoading) => {
  let story = {};
  if (args.sub) {
    args.sub = args.sub + "/" + storyID;
  } else {
    args.sub = "search/" + storyID;
  }

  const response = await api.get(`/stories/`, token, args, setLoading);

  if (response.status || response.success) {
    story = response.story;
  } else {
    cogoToast.error(response.message);
    return;
  }

  if (Object.keys(story).length > 0) {
    dispatch({
      type: "set",
      payload: {
        ...story,
        coverImageBackup: constants.covers[num()],
      },
    });
  }
};

const num = () => Math.floor(Math.random() * constants.covers.length);
